import styled from "styled-components";

export const Success = styled.section`
  text-align: center;
  padding: 7rem 0px;
  overflow: auto;
  overflow-y: hidden;
`;

